export const SEND_EMAIL = 'SEND_EMAIL';
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCES';
export const RESET_CONTACT_PAGE = 'RESET_CONTACT_PAGE';